import React from 'react';
import './App.scss';

import Banner from './components/Banner/Banner';
import EacCheck from './components/EacCheck/EacCheck';
import Contacts from './components/Contacts/Contacts';
import TextCols from "./components/TextCols/TextCols";
import AboutFunc from "./components/AboutFunc/AboutFunc";

import cols from "./content/cols.json";
import ContactBanner from "./components/ContactBanner/ContactBanner";

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      activePopup: null,
      region: "RU"
    }
  }

  componentDidMount() {
    const region = document.getElementsByTagName("html")[0].getAttribute("lang").toUpperCase();
    this.setState({ region });
  }

  changePopupVisibilityHandler = (popupData = null) => {
    this.setState({
      activePopup: popupData
    });
  };

  render() {

    const { activePopup, region } = this.state;

    return (
      <div className="App">
        <div className="site-container">
          <Banner />
          <TextCols cols={cols["cols"]} />
          <AboutFunc title={"Что нужно знать о&nbsp;качественных услугах и&nbsp;функциях LG Smart TV"}
                     text={"Читать далее"}
                     link={"https://www.lg.com/ru/lg-magazine/how-to/chto-nuzhno-znat-o-kachestvennykh-uslugakh-i-funktsii-lg-smart-tv"} />
          <EacCheck
            popupHandler={this.changePopupVisibilityHandler}
            activePopup={activePopup}
            region={region}
          />
          <ContactBanner />
          <Contacts />
        </div>
        {activePopup
          ? <div className="overlay" onClick={() => this.changePopupVisibilityHandler()}></div>
          : null
        }
      </div>
    );
  }
}

export default App;
